import { reportError } from "./error-reporting";

const _json = new Map<String, any>();
const _loadingPromises = new Map<String, Promise<void>>();

function withCacheBuster(url: string): string {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${Date.now()}`;
}

export async function loadJsonFromUrl<T>(url: string): Promise<T | null> {
  if (_json.has(url)) {
    return _json.get(url) as T;
  }

  if (_loadingPromises.has(url)) {
    await _loadingPromises.get(url);
    return _json.get(url) as T;
  }

  const loadingPromise = (async () => {
    try {
      const response = await fetch(withCacheBuster(url));
      if (!response.ok) {
        throw new Error(
          `Failed to load JSON from ${url}: ${response.statusText}`,
        );
      }
      const data = await response.json();
      _json.set(url, data);
    } catch (error) {
      reportError(`Error loading JSON from ${url}:`, error);
    } finally {
      _loadingPromises.delete(url);
    }
  })();

  _loadingPromises.set(url, loadingPromise);
  await loadingPromise;

  return (_json.get(url) as T) ?? null;
}
